import { render } from "./TripInfoComponent.vue?vue&type=template&id=79f5bf54&scoped=true"
import script from "./TripInfoComponent.vue?vue&type=script&lang=ts"
export * from "./TripInfoComponent.vue?vue&type=script&lang=ts"

import "./TripInfoComponent.vue?vue&type=style&index=0&id=79f5bf54&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-79f5bf54"

export default script